<template>
  <Modal
    class="modalPropostaStyle"
    :title="title"
    @click:close="closeModal"
    :active="internalActive"
    @close="closeModal"
  >
    <component :is="currentComponent" :cotacoes="cotacoes" @updateData="fetchData"/>
    <vs-pagination
      :max="screenWidth < 650 ? 5 : 9"
      :total="qtdPaginas || 0"
      v-model="paginaAtual"
      @change="handlePageChange"
    ></vs-pagination>
  </Modal>
</template>

<script>
import CotacaoAbertaComponent from './dashboard-resumo-proposta/CotacaoAbertaComponent.vue';
import AguardandoPagamentoComponent from './dashboard-resumo-proposta/AguardandoPagamentoComponent.vue';
import VistoriaExpiradaComponent from './dashboard-resumo-proposta/VistoriaExpiradaComponent.vue';
import AguardandoAprovacaoComponent from './dashboard-resumo-proposta/AguardandoAprovacaoComponent.vue';
import EmProcessoVistoriaComponent from './dashboard-resumo-proposta/EmProcessoVistoriaComponent.vue';
import PendenteComponent from './dashboard-resumo-proposta/PendenteComponent.vue';
import RecusadaComponent from './dashboard-resumo-proposta/RecusadaComponent.vue';
import FinalizadoComponent from './dashboard-resumo-proposta/FinalizadoComponent.vue';
import { STATUS_PROPOSTA } from '../../../utils/constants';
import reportsApi from '@/services/reports.api';
import CotacaoRecusadaComponent from './dashboard-resumo-proposta/CotacaoRecusadaComponent.vue';
import Modal from '../../../components/Modal.vue';

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    id_regional: {
      type: Number,
      default: null,
    },
    statusId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CotacaoAbertaComponent,
    AguardandoPagamentoComponent,
    VistoriaExpiradaComponent,
    AguardandoAprovacaoComponent,
    EmProcessoVistoriaComponent,
    PendenteComponent,
    RecusadaComponent,
    FinalizadoComponent,
    CotacaoRecusadaComponent,
    Modal
  },
  data() {
    return {
      internalActive: this.active,
      componentMap: {
        [STATUS_PROPOSTA.COTACAO_ABERTA.id]: CotacaoAbertaComponent,
        [STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.id]:
          AguardandoPagamentoComponent,
        [STATUS_PROPOSTA.VISTORIA_EXPIRADA.id]: VistoriaExpiradaComponent,
        [STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id]: AguardandoAprovacaoComponent,
        [STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id]: EmProcessoVistoriaComponent,
        [STATUS_PROPOSTA.PENDENTE.id]: PendenteComponent,
        [STATUS_PROPOSTA.FINALIZADO.id]: FinalizadoComponent,
        [STATUS_PROPOSTA.RECUSADA.id]: RecusadaComponent,
        [STATUS_PROPOSTA.COTACAO_RECUSADA.id]: CotacaoRecusadaComponent,
      },
      cotacoes: [],
      itemsPerPage: 10,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
    };
  },
  computed: {
    currentComponent() {
      return this.componentMap[this.statusId] || null;
    },
    screenWidth() {
      return window.innerWidth;
    },
  },
  methods: {
    async closeModal() {
      this.internalActive = false;
      this.$emit('close');
    },

    async fetchData() {
      this.$vs.loading();
      const id_regional = this.id_regional;
      const paginaAtual = this.paginaAtual;
      const itemsPerPage = this.itemsPerPage;
      const statusId = this.statusId;
      if (statusId) {
        await reportsApi
          .getAutoQuotationsReport(
            id_regional,
            statusId,
            paginaAtual,
            itemsPerPage,
          )
          .then((data) => {
            this.cotacoes = data.items;
            this.qtdTotal = data.total;
            this.qtdPaginas = Math.ceil(this.qtdTotal / this.itemsPerPage);
            this.$vs.loading.close();
            this.$emit('updateData');
          })
          .catch(() => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Nenhum registro encontrado',
              color: 'warning',
            });
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      } else {
        this.$vs.loading.close();
      }
    },
    async handlePageChange() {
      if (!this.paginaAtual) {
        return;
      }
      await this.fetchData();
    },
  },
  watch: {
    async active(newVal) {
      this.internalActive = newVal;
      if (newVal) {
        this.paginaAtual = 1;
        await this.fetchData();
      }
    },
  },
};
</script>

<style>
.modalPropostaStyle ul li:nth-child(odd) {
  background-color: rgb(241, 240, 240);
  border-radius: 5px;
}

@media screen and (max-width: 700px) {
  .modalPropostaStyle.con-vs-popup .vs-popup--content {
    padding: 0;
    margin: 0;
    font-size: 0.9rem;
  }
}

@media screen and (min-width: 900px) {
  .modalPropostaStyle.con-vs-popup .vs-popup {
    width: 70%;
  }
}
</style>
